var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mainNav"},[_c('div',{staticClass:"fsToggle"},[_c('div',{staticClass:"btn",on:{"click":_vm.fullscreen}})])])}
var staticRenderFns = []

export { render, staticRenderFns }